import { render, staticRenderFns } from "./TicketQueue.vue?vue&type=template&id=d313dbb8&scoped=true"
import script from "./TicketQueue.vue?vue&type=script&lang=js"
export * from "./TicketQueue.vue?vue&type=script&lang=js"
import style0 from "./TicketQueue.vue?vue&type=style&index=0&id=d313dbb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d313dbb8",
  null
  
)

export default component.exports